"use strict";

// Live Activity card (Workstream C).
//
// Two inputs, one list:
//   * server-rendered first page (already in the DOM when this runs)
//   * `rushworks:activity-event`, relayed from the socket by realtime.js
//
// Deliberately small. No transcript, no drill-down, no polling — if the
// socket is down the page still shows the server-rendered page and "Load
// more" still works, because that is a plain fetch.

(function () {
  var list = document.getElementById('activity-list');
  if (!list) return;

  var projectId = parseInt(list.getAttribute('data-project-id') || '', 10);
  var status = document.getElementById('activity-status');
  var moreBtn = document.getElementById('activity-more');
  var seen = Object.create(null);

  // Seed the dedupe set from what the server rendered, so a socket event that
  // races the page load cannot insert a duplicate.
  Array.prototype.forEach.call(list.querySelectorAll('[data-event-id]'), function (li) {
    seen[li.getAttribute('data-event-id')] = true;
  });

  function relativeTime(iso) {
    var then = new Date(iso).getTime();
    if (!then) return '';
    var secs = Math.max(0, Math.round((Date.now() - then) / 1000));
    if (secs < 60) return secs + 's ago';
    if (secs < 3600) return Math.round(secs / 60) + 'm ago';
    if (secs < 86400) return Math.round(secs / 3600) + 'h ago';
    return Math.round(secs / 86400) + 'd ago';
  }

  function render(ev) {
    var li = document.createElement('li');
    li.className = 'dash-activity__item';
    li.setAttribute('data-event-id', String(ev.id));

    var actor = document.createElement('span');
    actor.className = 'dash-activity__actor actor-' + ((ev.actor && ev.actor.kind) || 'system');
    actor.textContent = (ev.actor && ev.actor.label) || 'System';

    var label = document.createElement('span');
    label.className = 'dash-activity__label';
    label.textContent = ev.label;                 // textContent, never innerHTML

    var time = document.createElement('time');
    time.className = 'dash-activity__time';
    time.setAttribute('datetime', ev.created_on);
    time.textContent = relativeTime(ev.created_on);

    li.appendChild(actor);
    li.appendChild(label);
    li.appendChild(time);
    return li;
  }

  function prepend(ev) {
    if (!ev || seen[String(ev.id)]) return;
    seen[String(ev.id)] = true;
    var empty = list.querySelector('.dash-activity__empty');
    if (empty) empty.remove();
    list.insertBefore(render(ev), list.firstChild);
    if (status) {
      status.textContent = 'live';
      clearTimeout(status._t);
      status._t = setTimeout(function () { status.textContent = ''; }, 2500);
    }
  }

  window.addEventListener('rushworks:activity-event', function (e) {
    prepend(e.detail);
  });

  // Refresh relative timestamps in place so "12s ago" does not go stale.
  setInterval(function () {
    Array.prototype.forEach.call(list.querySelectorAll('time[datetime]'), function (t) {
      t.textContent = relativeTime(t.getAttribute('datetime'));
    });
  }, 30000);

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var before = moreBtn.getAttribute('data-before');
      if (!before) return;
      moreBtn.disabled = true;
      var base = window.location.pathname.replace(/\/dashboard.*$/, '');
      fetch(base + '/activity.json?before=' + encodeURIComponent(before), {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (page) {
          (page.events || []).forEach(function (ev) {
            if (seen[String(ev.id)]) return;
            seen[String(ev.id)] = true;
            list.appendChild(render(ev));       // older events go to the bottom
          });
          if (page.next_before) {
            moreBtn.setAttribute('data-before', String(page.next_before));
            moreBtn.disabled = false;
          } else {
            moreBtn.remove();
          }
        })
        .catch(function () { moreBtn.disabled = false; });
    });
  }
})();
